import React from "react";
import Footer from "../footer/Footer";
import "./Pages.css";
const Datenschutz = () => {
  return (
    <div className="datenschutz">
      <div>
        <p style={{ color: "#00387b", fontSize: 50, fontWeight: "bold" }}>
          DATENSCHUTZERKLÄRUNG
        </p>
      </div>

      <div>
        <Footer />
      </div>
    </div>
  );
};

export default Datenschutz;
